import React from 'react';
import { Link } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import logo from '../images/nordania-leasing-logo.svg'; 

const useStyles = makeStyles({
  logo: {
    width: "235px",
  },
})

export default function Logo() {
  const classes = useStyles();
  return (
    <Link to="#">
      <img src={logo} className={classes.logo} alt="Nordania Leasing"/>
    </Link>
  );
}
